<template>
<div>
  <b-tabs v-on:input="changedTab" >
    <b-tab title="DSR" active>
        <Grid v-if="currentTab==0" name="modaldsrGrid" ref="modaldsrGrid" v-bind:url="urlDsr" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
    </b-tab>
    <b-tab title="Leaders" >
        <Grid v-if="currentTab==1" name="modalLeadersGrid" ref="modalLeadersGrid" v-bind:url="urlLeaders" v-bind:columns="columnsLeaders" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
    </b-tab>
    <b-tab title="Managers" >
        <Grid v-if="currentTab==2" name="modalManagersGrid" ref="modalManagersGrid" v-bind:url="urlManagers" v-bind:columns="columnsManagers" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
    </b-tab>
  </b-tabs>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import lists from '@/components/States.js'
export default {
  name: 'Client',
  props: ['height'],
  components: {
    Grid
  },
  data() {
    return {
      preload: [{
        api:'dealers/lst',
        field: 'dealer_id'
      }],
      schemaModelFields: {},
      urlDsr: 'dsr/dsr',
      urlLeaders: 'dsr/leaders',
      urlManagers: 'dsr/managers',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'Selecionar',
          click: this.selectItem
        }
      }, {
        field: 'id',
        title: 'Id',
        width: '80px'
      }, {
        field: 'name',
        title: 'Nome',
        width: '180px'
      }, {
        field: 'dsr_type',
        title: 'Tipo',
        width: '180px',
        values: lists.dsrTypes
      }, {
        field: 'inparuser.data.username',
        title: 'Nome de utilizador',
        sortable: false,
        width: '120px'
      }, {
        field: 'state',
        title: 'Estado',
        width: '180px',
        values: lists.dsrStates
      }, {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '180px'
      }],
      columnsLeaders: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'Selecionar',
          click: this.selectLeader
        }
      }, {
        field: 'id',
        title: 'Id',
        width: '80px'
      }, {
        field: 'name',
        title: 'Nome',
        width: '180px'
      }, {
        field: 'dsr_type',
        title: 'Tipo',
        width: '180px',
        values: lists.dsrTypes
      }, {
        field: 'inparuser.data.username',
        title: 'Nome de utilizador',
        sortable: false,
        width: '120px'
      }, {
        field: 'state',
        title: 'Estado',
        width: '180px',
        values: lists.dsrStates
      }, {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '180px'
      }],
      columnsManagers: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'Selecionar',
          click: this.selectManager
        }
      }, {
        field: 'id',
        title: 'Id',
        width: '80px'
      }, {
        field: 'name',
        title: 'Nome',
        width: '180px'
      }, {
        field: 'dsr_type',
        title: 'Tipo',
        width: '180px',
        values: lists.dsrTypes
      }, {
        field: 'inparuser.data.username',
        title: 'Nome de utilizador',
        sortable: false,
        width: '120px'
      }, {
        field: 'state',
        title: 'Estado',
        width: '180px',
        values: lists.dsrStates
      }, {
        field: 'dealer_id',
        title: 'Distribuidor',
        width: '180px'
      }],
      currentTab: 0,
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    }
  },
  methods: {
    changedTab(e) {
      this.currentTab = e;
    },
    selectItem(e) {
      e.preventDefault()
      var grid = this.$refs.modaldsrGrid.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('select-item', {
        item: dataItem
      })
    },
    selectLeader(e) {
      e.preventDefault()
      var grid = this.$refs.modalLeadersGrid.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('select-item', {
        item: dataItem
      })
    },
    selectManager(e) {
      e.preventDefault()
      var grid = this.$refs.modalManagersGrid.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('select-item', {
        item: dataItem
      })
    }
  }
}
</script>
